import Yup from '~/utils/validations/yup';

export const schemaValidation = Yup.object({
  name: Yup.string().when('currentStep', {
    is: 0,
    then: Yup.string().required(),
  }),
  description: Yup.string().when('currentStep', {
    is: 0,
    then: Yup.string().required().max(500),
  }),
  logo: Yup.mixed().when('currentStep', {
    is: 1,
    then: Yup.mixed().required(),
  }),
  apps: Yup.array(Yup.mixed()),
  isPrivate: Yup.boolean(),
  currentStep: Yup.number().required(),
  causeOptions: Yup.array(
    Yup.object({ label: Yup.string(), value: Yup.string() }),
  ).min(1, 'At least one cause option is required'),
  measurementUnits: Yup.array(
    Yup.object({ label: Yup.string(), value: Yup.string() }),
  ).min(1, 'At least one measurement unit is required'),
  downloadableFiles: Yup.array().of(
    Yup.object({
      name: Yup.string()
        .required('Name is required')
        .max(50, 'Name must be at most 50 characters'),
      link: Yup.string().required('URL is required').url('Must be a valid URL'),
      description: Yup.string()
        .trim()
        .max(152, 'Description must be at most 152 characters'),
    }),
  ),
});

export const defaultValues = {
  currentStep: 0,
  isPrivate: false,
  causeOptions: [],
  downloadableFiles: [],
  measurementUnits: [],
};
